import './App.css';
import { useRoutes } from 'react-router-dom';
import Login from './components/Auth/Login';
import LoginRedirect from 'components/Auth/LoginRedirect';
import Layout from './components/Layout/Layout';
import Home from 'components/Home/Home';
import NotFound from 'components/Common/NotFound';
import Versions from 'components/Workplaces/Versions/Versions'
import Maintenance from 'components/Workplaces/Maintenance/Maintenance';

function App() {
    const workplaces = [
        { path: '*', element: <NotFound /> },
        { 
            path: '/',
            element: <Home />,
            children: [
                { path: '/', element: <Versions /> },
                { path: '/maintenance', element: <Maintenance /> },
            ]
        },
    ];


    const element = useRoutes([
        {
            path: '/',
            element: <Layout />,
            children: [
                {
                    path: '/',
                    element: <LoginRedirect />,
                    children: workplaces,
                },                
                { path: '/login', element: <Login /> },
            ],
        },
    ]);

    return (
        <>
            {element}
        </>
    );
}

export default App;
